<template>
    <div class="mbg"  :style="{background:bgGif}" :class="[root.device=='phone'&&'notransform']">
        <div class="yf-layout myrow1">
          <div>歌莉娅数据可视化系统</div>
         
        </div>
     <div   v-if="root.device!='phone'" class="mswiper" :class="diveStyle"  :style="{'opacity':tt}">
                          <van-checkbox-group v-model="result" >

    <swiper :options="swiperOptions">
      <swiper-slide class="mitem-default " >
    <van-row  type="flex"  justify='space-between' style="width:100%;">
                           
  <van-col :span="5"  v-permission="['kanban:bottom']">
      <van-checkbox v-show='false' class="checkBox"  :name="0"/>
      <div  @click="openUrl(1)" class="box-item" @mouseover="hoverBg(1)">
         <div style="position:relative;width:100%">
                       
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/1.png" alt="">
              <img class="item-mask" :style="{display:isShow===1?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">BOTTOM数据看板</div>
      </div>
  </van-col>
   <van-col :span="5"  v-permission="['kanban:bigop']">
       <van-checkbox v-show='false' class="checkBox"  :name="1"/>
      <div @click="openUrl(2)" class="box-item" @mouseover="hoverBg(2)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/2.png" alt="">
              <img class="item-mask" :style="{display:isShow===2?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅大店运营看板</div>
      </div>
  </van-col>
   <van-col :span="5"  v-permission="['kanban:supply']">
  <van-checkbox v-show='false' class="checkBox"  :name="2"/>
  <div @click="openUrl(3)" class="box-item" @mouseover="hoverBg(3)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/3.png" alt="">
              <img class="item-mask" :style="{display:isShow===3?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">供应链数据分析看板</div>
      </div>
  </van-col>
   <van-col :span="5"  v-permission="['kanban:design']">
    <van-checkbox v-show='false' class="checkBox"  :name="3"/>
    <div @click="openUrl(4)" class="box-item" @mouseover="hoverBg(4)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/4.png" alt="">
              <img class="item-mask" :style="{display:isShow===4?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅设计研发看板</div>
      </div>
  </van-col>
  <van-col :span="5"  v-permission="['kanban:vip']">
     <van-checkbox v-show='false' class="checkBox"  :name="4"/>
     <div @click="openUrl(5)" class="box-item" @mouseover="hoverBg(5)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/5.png" alt="">
              <img class="item-mask" :style="{display:isShow===5?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅会员分析看板</div>
      </div>
  </van-col>
   <van-col :span="5"  v-permission="['kanban:production_1']">
 <van-checkbox v-show='false' class="checkBox"  :name="5"/>
 <div @click="openUrl(6)" class="box-item" @mouseover="hoverBg(6)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/6.png" alt="">
              <img class="item-mask" :style="{display:isShow===6?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅数字化生产一</div>
      </div>
  </van-col>

<!-- 新增员工产能排行 -->
<van-col :span="5" >
    <van-checkbox v-show='false' class="checkBox"  :name="6"/>
    <div @click="openUrl(7)" class="box-item" @mouseover="hoverBg(7)">
            <div style="position:relative;width:100%">
                 <img   mode='aspectFit' style="width:60%" src="../../assets/main/6.png" alt="">
                 <img class="item-mask" :style="{display:isShow===7?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
            </div>
             <div style="color:white;margin-top:20px">歌莉娅员工产能排行</div>
    </div>
</van-col>

   <van-col :span="5"  v-permission="['kanban:production_2']">
  <van-checkbox v-show='false' class="checkBox"  :name="7"/>
  <div @click="openUrl(8)" class="box-item" @mouseover="hoverBg(8)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/7.png" alt="">
              <img class="item-mask" :style="{display:isShow===8?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅数字化生产二</div>
      </div>
  </van-col>
</van-row>

  </swiper-slide>
  <swiper-slide class="mitem-default">
 <van-row  type="flex" justify='space-between'  style="width:100%">
    <van-col :span="5"   v-permission="['kanban:online']">
        <van-checkbox v-show='false' class="checkBox"  :name="8"/>
        <div @click="openUrl(9)" class="box-item" @mouseover="hoverBg(9)">
             <div style="position:relative;width:100%">
                  <img   mode='aspectFit' style="width:60%" src="../../assets/main/8.png" alt="">
                  <img class="item-mask" :style="{display:isShow===9?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
             </div>
              <div style="color:white;margin-top:20px">歌莉娅线上运营看板</div>
          </div>
      </van-col>
  <van-col :span="5"  v-permission="['kanban:schedule']">
 <van-checkbox v-show='false' class="checkBox"  :name="9"/>
 <div @click="openUrl(10)" class="box-item" @mouseover="hoverBg(10)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/9.png" alt="">
              <img class="item-mask" :style="{display:isShow===10?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅新款进度看板</div>
      </div>
  </van-col>
   <van-col :span="5" v-permission="['kanban:marketing']">
  <van-checkbox v-show='false' class="checkBox"  :name="10"/>
  <div @click="openUrl(11)"  class="box-item" @mouseover="hoverBg(11)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/10.png" alt="">
              <img class="item-mask" :style="{display:isShow===11?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">新款上市销售监测</div>
      </div>
  </van-col>
   <van-col :span="5" v-permission="['kanban:operate']">
<van-checkbox v-show='false' class="checkBox"  :name="11"/>
<div @click="openUrl(12)"  class="box-item" @mouseover="hoverBg(12)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/11.png" alt="">
              <img class="item-mask" :style="{display:isShow===12?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅运营数据看板</div>
      </div>
  </van-col>
    <van-col :span="5"   v-permission="['kanban:quality']">
     <van-checkbox v-show='false' class="checkBox"  :name="12"/>
     <div @click="openUrl(13)" class="box-item" @mouseover="hoverBg(13)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/12.png" alt="">
              <img class="item-mask" :style="{display:isShow===13?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅质检看板</div>
      </div>
  </van-col>
   <van-col :span="5"  v-permission="['kanban:warehouse']">
    <van-checkbox v-show='false' class="checkBox"  :name="13"/>
    <div @click="openUrl(14)" class="box-item" @mouseover="hoverBg(14)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/13.png" alt="">
              <img class="item-mask" :style="{display:isShow===14?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅仓库看板</div>
      </div>
  </van-col>

  <van-col :span="5">
    
  </van-col>
  <van-col :span="5">
    
 </van-col>
</van-row>
                        </swiper-slide>
                      
                        <!-- Add Arrows -->

            
                    </swiper>
                    </van-checkbox-group>
                         <div class="swiper-button-prev" >
                            <img src="@/assets/main/arrL1.png"/>
                        </div>
                        <div class="swiper-button-next" >
                             <img src="@/assets/main/arrR1.png"/>
                        </div>

      <div style="z-index: 99999999;;font-size:20px;font-weight:800;color:#fff;position:fixed;bottom:0px;left:50%;transform:translateX(-50%)">
        <div style="display:flex;;flex-direction: column;align-items: center;">
            <span style="padding: 15px;background-color:rgba(50, 41, 56, 0.7);border-radius: 10px 10px 0 0;" v-if="screen3" @click="linkSplitScreen(3)" class="txt_c">3屏显示</span>
              <!-- <span style="padding: 15px;background-color:rgba(50, 41, 56, 0.7);border-radius: 10px 10px 0 0;" v-if="screen4" @click="linkSplitScreen(4)" class="txt_c">4屏显示</span>
              <span style="padding: 15px;background-color:rgba(50, 41, 56, 0.7);border-radius: 10px 10px 0 0;margin: 0 200px;" v-if="screen6" @click="linkSplitScreen(6)" class="txt_c" >6屏显示</span>
              <span style="padding: 15px;background-color:rgba(50, 41, 56, 0.7);border-radius: 10px 10px 0 0;" v-if="screen9" @click="linkSplitScreen(9)" class="txt_c">9屏显示</span> -->
              <span   @click="switchSplit()" style="padding: 15px;background-color:rgba(50, 41, 56, 0.7);border-radius: 10px 10px 0 0;display: none"><span  class="txt_c">{{splitTxt}}</span></span>
          
          <div v-show="showSplit" style="width:100vw;display: flex;justify-content:center;align-items: center;background-color: rgba(50, 41, 56, 0.7);height: 70px;">
              <span  @click="linkSplitScreen(4)" class="txt_c">4屏显示</span>
              <span  @click="linkSplitScreen(6)" class="txt_c" style="margin: 0 200px;">6屏显示</span>
              <span  @click="linkSplitScreen(9)" class="txt_c">9屏显示</span>
          </div>
        </div>
      </div>
     </div>
            <div   v-else class="mswiper notransform" :class="diveStyle"  :style="{'opacity':tt}">

                  <swiper 
                    :options="swiperOptions"       
                         
                    >
                       <swiper-slide class="mitem-default " >
                           
<van-row :gutter="50" type="flex"  style="width:100%">
  <van-col :span="6"  @click="openUrl(1)" v-permission="['kanban:bottom']">
      <div class="box-item" @mouseover="hoverBg(1)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/1.png" alt="">
              <img class="item-mask" :style="{display:isShow===1?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">BOTTOM数据看板</div>
      </div>
  </van-col>
   <van-col :span="6"  @click="openUrl(2)" v-permission="['kanban:bigop']">
      <div class="box-item" @mouseover="hoverBg(2)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/2.png" alt="">
              <img class="item-mask" :style="{display:isShow===2?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅大店运营看板</div>
      </div>
  </van-col>
   <van-col :span="6"  @click="openUrl(3)" v-permission="['kanban:supply']">
  <div class="box-item" @mouseover="hoverBg(3)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/3.png" alt="">
              <img class="item-mask" :style="{display:isShow===3?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">供应链数据分析看板</div>
      </div>
  </van-col>
   <van-col :span="6"  @click="openUrl(4)" v-permission="['kanban:design']">
    <div class="box-item" @mouseover="hoverBg(4)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/4.png" alt="">
              <img class="item-mask" :style="{display:isShow===4?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅设计研发看板</div>
      </div>
  </van-col>
  <van-col :span="6"  @click="openUrl(5)" v-permission="['kanban:vip']">
     <div class="box-item" @mouseover="hoverBg(5)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/5.png" alt="">
              <img class="item-mask" :style="{display:isShow===5?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅会员分析看板</div>
      </div>
  </van-col>
   <van-col :span="6"  @click="openUrl(6)" v-permission="['kanban:production_1']">
 <div class="box-item" @mouseover="hoverBg(6)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/6.png" alt="">
              <img class="item-mask" :style="{display:isShow===6?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅数字化生产一</div>
      </div>
  </van-col>
   <van-col :span="6"  @click="openUrl(7)" v-permission="['kanban:production_2']">
  <div class="box-item" @mouseover="hoverBg(7)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/7.png" alt="">
              <img class="item-mask" :style="{display:isShow===7?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅数字化生产二</div>
      </div>
  </van-col>
 
</van-row>
</swiper-slide>
<swiper-slide class="mitem-default">
<van-row :gutter="50" type="flex" style="width:100%">
  <van-col :span="6"  @click="openUrl(8)" v-permission="['kanban:online']">
      <div class="box-item" @mouseover="hoverBg(8)">
           <div style="position:relative;width:100%">
                <img   mode='aspectFit' style="width:60%" src="../../assets/main/8.png" alt="">
                <img class="item-mask" :style="{display:isShow===8?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
           </div>
            <div style="color:white;margin-top:20px">歌莉娅线上运营看板</div>
        </div>
    </van-col>
  <van-col :span="6"  @click="openUrl(9)" v-permission="['kanban:schedule']">
 <div class="box-item" @mouseover="hoverBg(9)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/9.png" alt="">
              <img class="item-mask" :style="{display:isShow===9?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅新款进度看板</div>
      </div>
  </van-col>
   <van-col :span="6"  @click="openUrl(10)" v-permission="['kanban:marketing']">
  <div class="box-item" @mouseover="hoverBg(10)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/10.png" alt="">
              <img class="item-mask" :style="{display:isShow===10?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">新款上市销售监测</div>
      </div>
  </van-col>
   <van-col :span="6"  @click="openUrl(11)" v-permission="['kanban:operate']">
<div class="box-item" @mouseover="hoverBg(11)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/11.png" alt="">
              <img class="item-mask" :style="{display:isShow===11?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅运营数据看板</div>
      </div>
  </van-col>
    <van-col :span="6"  @click="openUrl(12)" v-permission="['kanban:quality']">
     <div class="box-item" @mouseover="hoverBg(12)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/12.png" alt="">
              <img class="item-mask" :style="{display:isShow===12?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅质检看板</div>
      </div>
  </van-col>
   <van-col :span="6"  @click="openUrl(13)" v-permission="['kanban:warehouse']">
    <div class="box-item" @mouseover="hoverBg(13)">
         <div style="position:relative;width:100%">
              <img   mode='aspectFit' style="width:60%" src="../../assets/main/13.png" alt="">
              <img class="item-mask" :style="{display:isShow===13?'block':'none'}"  mode='aspectFit'  src="../../assets/main/hover.png" alt="">
         </div>
          <div style="color:white;margin-top:20px">歌莉娅仓库看板</div>
      </div>
  </van-col>

 
</van-row>
                        </swiper-slide>
                      
                        <!-- Add Arrows -->
            
                    </swiper>
                         <div class="swiper-button-prev" >
                            <img src="@/assets/main/arrL1.png"/>
                        </div>
                        <div class="swiper-button-next" >
                             <img src="@/assets/main/arrR1.png"/>
                        </div>
     </div>
    </div>

     
</template>
<script>
 import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import permission from '@/api/permission.js' // 权限判断指令
import 'swiper/css/swiper.css'
export default {
	directives: { permission},
     inject:['root'],
     data(){
         return {
             splitTxt:'分屏显示',
             screen3:false,
             screen4:false,
             screen6:false,
             screen9:false,
             showCheckBox:false,
             result:[],
             showSplit:false,
             timer:null,
             bgGif:'',
             isShow:0,
             tt:0,
            swiperOptions:{
                  slidesPerGroup: 1,
                 on: {
                    init: ()=>{
                        setTimeout(()=>{

                            this.tt=1;
                        },800)
                         
                    }
                },
       
                // slidesPerView: this.root.device=='pc'?4:3,
                //  spaceBetween: 5,
            //    observer:true,
                // centeredSlides: true,
               autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: true,
                },
                // loop: true, 
                
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            }
         }
     },
    //  watch: {
    //      result(arr){
    //          let len=arr.length
    //          this.screen6=false
    //          this.screen9=false
    //          this.screen4=false
    //          this.screen3=false
    //           if(len===3){
    //          this.screen6=false
    //          this.screen9=false
    //          this.screen4=false
    //            this.screen3=true
    //          }
    //          if(len===4){
    //          this.screen6=false
    //          this.screen9=false
    //               this.screen3=false
    //          this.screen4=true
    //          }
    //           if(len===6){
    //          this.screen6=true
    //          this.screen9=false
    //         this.screen3=false
    //          this.screen4=false
    //          }
    //           if(len===9){
    //          this.screen6=false
    //          this.screen3=false
    //          this.screen9=true
    //          this.screen4=false
    //          }
    //      }
    //  },
     computed:{
       diveStyle:function(){
           const list=[];           
           list.push(this.root.device)
           console.log(list)
           return list;
       }
     },
     components: {
      Swiper,
      SwiperSlide,
    },
    methods:{
        linkSplitScreen(val){
            // let len=this.result.length
            this.$router.push('/platm/Multiple?index='+val)
        },
        switchSplit(){
            
            if(this.showSplit){
                 this.splitTxt='分屏显示'
                this.result=[]
            }else{
                this.splitTxt='取消分屏'
            }
            this.showSplit=!this.showSplit
                this.showCheckBox=this.showSplit

        },
        loadImage(url,callback) {
    var img = new Image(); //创建一个Image对象，实现图片的预下载
    img.src = url;
    img.onload = function(){
        callback(img);
    };
},
setImage(img){
      this.bgGif="url("+img.src+")"+"no-repeat  center -50px/ 92% #1f2847"
},
        hoverBg(val){
            this.isShow=val
            // console.log(214214312)
        },
          bannerSwiperClick(){
            let that = this,
            ind = this.$refs.mySwiper.$swiper.activeIndex+1 //获取下标4
         
           this.openUrl(ind)
          
        },
        openUrl(id){
            this.$router.push('/single?index='+id)
            return
            var o={};         
         
            switch (id) {
                case 1:
                    o.name='bottom'
                    break;
                case 2:
                     o.name='bigop';
                     o.params={
                         id:"2689E844B02048C28DEE33577FFCECCE"
                     }
                    break;
                case 3:
                     o.name='supply'
                    break;
                case 4:
                     o.name='design'
                    break;
                case 5:
                     o.name='vip2'
                    break;
                case 6:
                     o.name='digitalproduction_1'
                    break;
                case 7:
                     o.name='capacity'
                     break;
                case 8:
                     o.name='digitalproduction_2'
                    break;
                case 9:
                     o.name='online'
                    break;
                case 10:
                     o.name='production_schedule'
                    break;
                case 11:
                     o.name='marketing'
                    break;
                case 12:
                     o.name='operate'
                    break;
                case 13:
                     o.name='quality_testing'
                    break;
                case 14:
                     o.name='warehouse'
                    break;
                
                default:
                    break;
            }
           this.$router.push(o)
        }
    },
    // 开启定时器
activated(){
	 this.timer= setInterval(()=>{
          this.bgGif= require('../../assets/main/bgGif2.gif')+'?'+Math.random()
          this.loadImage(this.bgGif,this.setImage)
        },3200)
},
// 关闭定时器
deactivated(){
            this.splitTxt='分屏显示'
            // this.screen3=false
            // this.screen4=false
            // this.screen6=false
            // this.screen9=false
            // this.showCheckBox=false
            // this.result=[]
            this.showSplit=false
clearInterval(this.timer)
}
}
</script>
<style lang='scss' scoped>
.item-mask{
width:60%;
position:absolute;
bottom:20px;
left:50%;
transform: translateX(-50%);
opacity:0.4
}
.box-item{
width:90%;
height:320px;
display:flex;
flex-direction: column;
justify-content: start;
align-items: center;
}
.myrow1{
    margin-bottom: 50px;
    color: #fff;
    font-size: 48px;
}
.mbg{
    background:url(../../assets/main/bgGif.gif) no-repeat  center -50px/ 92% #1f2847;
    display: flex;
    align-items: center;
    flex-direction: column;
        // background-size: cover;
    // background-repeat: no-repeat;
    // background-position: center;
}
html, body {
      position: relative;
      height: 100%;
      
    }
    body {
      background: #eee;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 14px;
      color:#000;
      margin: 0;
      padding: 0;
    }
    .swiper-container {
      width: 100%;
      height: 100%;
    }
    .swiper-slide {
      text-align: center;
      font-size: 18px;

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
	  transition: 300ms;
	  transform: scale(0.9);
    }
    :focus {
        outline: none
    }
    .mswiper{
        position: relative;
        opacity: 0;
    }
    .mswiper{
        &.phone{
            width:80vw;
            height: 40vw;
        }
        
    }
    .mswiper{
        &.pc{
            width:1300px;
            height: 612px; 
        }
      
    }
    .mswiper{
         &.ipad{
           width:65.41vw;
           height: 40vw; 
        }
    }    
   
    // .mitem-default .dy{
    //     background: linear-gradient(blue,green);
    //     opacity: 0.2;
    // }
    // .mitem-default.swiper-slide-next{
    //   transform: scale(1);
    // }
       
    // .mitem-default.swiper-slide-next .bg{
         
    //     background: linear-gradient(#fdb800,#dd5200);
    // }
    // .mitem-default.swiper-slide-next .dy{
    //     background: linear-gradient(#dd5200,#fdb800);
    // }
    .swiper-button-prev:after, .swiper-button-next:after {
        content: '' !important;
           outline: none !important;
     }
     .swiper-button-prev{
         top:40%;
         width:58px;
             left: -90px;
        img{
          width:100%;
        }
     }
     .swiper-button-next{
             width:58px;
             right: -90px;
             top:40%;
        img{
          width:100%;
        }
     }
    .yf-layout{
        margin-top: 50px;
        height: 90px;
        width: 940px;
        background:url('../../assets/main/bg2.png') no-repeat  center / 100% ;
        display: flex;
        align-items: center;
        justify-content: center;
    }
   .txt_c{
//        background-image:-webkit-linear-gradient(bottom,#616d96,#fff);
// -webkit-background-clip:text;
// -webkit-text-fill-color:transparent;
text-shadow: #9d9db8 0 1px 5px;
cursor: pointer;
   }
   .checkBox{
       padding:20px;
       position: absolute;
       z-index: 9999;
   }
</style>